import React from 'react'
import { Box, PageTitle } from '@perk-ui/core'

// import { ArrowLeft } from 'react-feather'
// import { useHistory } from 'react-router'
import TableauView from '../../components/TableauView'
import queryClient from '../../config/react-query'
import { useUser } from '../../features/auth/AuthContext'
// import { useUser } from '../../features/auth/AuthContext'
import QueryKeys from '../../features/query-hooks/QueryKeys'

interface QuickStatsProps {}

const QuickStats: React.FC<QuickStatsProps> = () => {
  const currentUser = useUser()
  // const { goBack } = useHistory()
  const accessUserTableauSubscription =
    currentUser?.accessUser?.sponsor?.subscriptionPlan || ''
  queryClient.invalidateQueries(
    QueryKeys.tableauToken(
      'quick-stats',
      'views/quick_stats/QuickStatsScorecard',
    ),
  )

  const getWorkbookUrl = () => {
    switch (accessUserTableauSubscription) {
      case 'basic':
      case 'standard':
        return ''
      case 'premium':
        return 'views/quick_stats/QuickStatsScorecard'
      default:
        return ''
    }
  }

  const QuickStatsTableauParameters = [
    {
      key: 'parameter_select_subscription_type',
      value: 'ACCESS',
    },
    // {
    //   key: 'parameter_select_sponsor_id',
    //   value: currentUser?.accessUser?.sponsorId,
    // },
    // {
    //   key: 'parameter_select_sponsored_user_id',
    //   value: currentUser?.accessUser?.id,
    // },
  ]

  return (
    <Box p={3}>
      <PageTitle title="Raw Data" />
      {/* <Box display="flex" alignItems={'center'} p={2}>
        <IconButton onClick={() => goBack()}>
          <ArrowLeft />
        </IconButton>
        <H3>Quick Stats</H3>
      </Box> */}
      {getWorkbookUrl() && (
        <TableauView
          src={getWorkbookUrl()}
          toolbar="top"
          hideTabs={false}
          section="quick-stats"
          parameters={QuickStatsTableauParameters}
        />
      )}
    </Box>
  )
}

export default QuickStats
